import firebase from "firebase";

let config = {
  apiKey: "AIzaSyCAh5aa58yzz1denuBZTtay3ZQhcizbnK0",
  authDomain: "aprovado-7f331.firebaseapp.com",
  databaseURL: "https://aprovado-7f331.firebaseio.com",
  projectId: "aprovado-7f331",
  storageBucket: "aprovado-7f331.appspot.com",
  messagingSenderId: "900481748828"
};
let fire = firebase.initializeApp(config);

export const auth = firebase.auth();
export const db = firebase.firestore();
export const storage = fire.storage();
export const fbFunctions = fire.functions();

export default fire;
